(function ($) {
    var templateUrl = object_name.templateUrl;

    $( document ).ready(function () {
        let win_width = $(window).width();

        // if(win_width >= 768 && win_width <= 991){
        //     $('#navbarSupportedContent').removeClass('collapse');
        // }

        var prevScrollpos = window.pageYOffset;

        window.onscroll = function() {

            var currentScrollPos = window.pageYOffset;

            if (prevScrollpos > currentScrollPos) {
                document.getElementById("nav-full-box").style.top = "0";
            } else {
                let page_header_1 = $('#nav-full-box').outerHeight();
                document.getElementById("nav-full-box").style.top = "-"+page_header_1+"px";
            }
            prevScrollpos = currentScrollPos;

            if($('.csBanner-makai').length > 0){
                if(currentScrollPos == 0){//top
                    $('.container-main').addClass('inherit-menu').removeClass('white-menu');
                }else{
                    $('.container-main').removeClass('inherit-menu').addClass('white-menu');
                }
            }
        }

        let contentFullHeigh = $('.page-template-default #primary, .page-template-page-fullpage #primary, .page-template-template-default #primary');

        if(contentFullHeigh.length > 0){
            let page_header = $('#nav-full-box').outerHeight();
            let page_footer = $('#simple-footer').outerHeight();

            let offset = page_footer;

            if(window.location.pathname == '/'){//home page
                contentFullHeigh.css({'minHeight': 'calc(100vh'});
                $('#simple-footer').hide();
            }else{
                contentFullHeigh.css({'minHeight': 'calc(100vh - '+ offset +'px)'});
                contentFullHeigh.css({'paddingTop': +page_header+'px'});
                $('#simple-footer').show();
            }
        }

        contentFullHeigh = $('.page-template-page-fullpage.home #primary');

        if(contentFullHeigh.length > 0){
            let page_footer = $('#simple-footer').outerHeight();

            let offset = page_footer;

            if(window.location.pathname == '/'){//home page
                contentFullHeigh.css({'minHeight': 'calc(100vh'});
                $('#simple-footer').hide();
            }else{
                contentFullHeigh.css({'minHeight': 'calc(100vh - '+ offset +'px)'});
                $('#simple-footer').show();
            }
        }
        if($('span.comment').size() > 0){
            if($(window).height() >= 789){
                $('.des-contact-form').css('margin-bottom', '25px');
                $('span.comment textarea').height(120);
            }
            $('.select-wrapper').prepend('<img class="img-dd-arrow-down" src="'+templateUrl+'icon/arrow-select-dd.png" />')
        }

        let contentFullHeighSingle = $('.single-post-container-ct');

        if(contentFullHeighSingle.length > 0){
            let page_header = $('#nav-full-box').outerHeight();
            let page_footer = $('#simple-footer').outerHeight();

            let offset = page_footer;

            contentFullHeighSingle.css({'minHeight': 'calc(100vh - '+ (offset + 25) +'px)'});
            contentFullHeighSingle.css({'paddingTop': +page_header+'px'});
        }

        let contentFullHeighstories = $('.stories-container-ct');

        if(contentFullHeighstories.length > 0){
            let page_header = $('#nav-full-box').outerHeight();
            let page_footer = $('#simple-footer').outerHeight();

            let offset = page_footer;

            contentFullHeighstories.css({'minHeight': 'calc(100vh - '+ (offset + 25) +'px)'});
            contentFullHeighstories.css({'paddingTop': +page_header+'px'});
        }

        let contentFullHeighMaps = $('#map');

        if(contentFullHeighMaps.length > 0){
            let page_header = $('#nav-full-box').outerHeight();

            let offset = page_header;

            if($(window).width() >= 789){
                contentFullHeighMaps.css({'height': 'calc(100vh - '+ offset +'px)'});
            }else{
                contentFullHeighMaps.css({'height': 'calc(100vh)'});
            }
            $('.container-main').addClass('white-menu');
            $('#simple-footer').hide();
        }

        if($('#pac-input').size() > 0){
            $('.input-search-ct').prepend('<img class="img-search-ct" src="'+templateUrl+'icon/search-icon.png" />')
            $('.input-search-ct').prepend('<div class="x-mark-containers"><span class="x-mark-ct" aria-hidden="true">&times;</span></div>')
        }

        let contentFullHeighBanner = $('.csBanner-makai');

        if(contentFullHeighBanner.length > 0){
            $('.container-main').addClass('inherit-menu');
        }

        if($('.cs-half-section-ct').length > 0){

            if(win_width <= 991) {//ipad
                $('#simple-footer').addClass('footer-mobile');
            }
        }
    });


})(jQuery);
